export const RectIcon = () => {
  return (
    <svg fill="none" height="18" viewBox="0 0 18 18" width="18">
      <rect
        height="16"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.68"
        width="16"
        x="1"
        y="1"
      />
    </svg>
  );
};
